module.exports = __webpack_public_path__ + "static/accuracy-Biopsy-1d083a838ddd98463bc0f55a67ec8100.png";